module.exports = __webpack_public_path__ + "img/bottom_ercode1.06bfd750.png";